import React from "react";

import Select from "../index";

export default function Type(props) {
  const items = ["PAYSLIP", "TAXRETURN"];

  return <Select label="Type" items={items} {...props} />;
}
